export default "__VITE_ASSET__BgE9E3zH__"